export default {
  UPDATE_UNI_NAV_COLLAPSED: 'UPDATE_UNI_NAV_COLLAPSED',
  UPDATE_IS_CREATE_PAGE: 'UPDATE_IS_CREATE_PAGE',
  UPDATE_IS_SHOW_REGION_SELECT: 'UPDATE_IS_SHOW_REGION_SELECT',
  UPDATE_MESSAGE_COUNT: 'UPDATE_MESSAGE_COUNT',
  UPDATE_UNREAD_MESSAGE: 'UPDATE_UNREAD_MESSAGE',
  UPDATE_ACCOUNT_REMAINDER: 'UPDATE_ACCOUNT_REMAINDER',
}